require('slick-carousel/slick/slick.min.js');


var navigationCarousel = {
	SiteControl: null,
	$container: null,
	$carousel: null,
	addingSlides: false,

	init: function(SiteControl) {
		this.SiteControl = SiteControl;
		this.$container = $('.js-navigation-carousel');

		if (!this.$container.length) {
			return false;
		}

		this.initSlider();
	},

	/**
	 * Initialises the carousel and sets up lazy loading
	 */
	initSlider: function() {
		var _this = this;

		this.$container.on('init', function() {
			_this.$container.css({'overflow': 'visible'});
		});

		this.$carousel = this.$container.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			initialSlide: this.getStartPosition(),
			arrows: true,
			infinite: false,
			prevArrow: '<button type="button" class="navigation-carousel__control navigation-carousel__control--prev"><i class="fa fa-chevron-left"></i></button>',
			nextArrow: '<button type="button" class="navigation-carousel__control navigation-carousel__control--next"><i class="fa fa-chevron-right"></i></button>',
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

		// lazy loading
		this.$carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

			// prepend with some new ones
			if (currentSlide > nextSlide && currentSlide <= 3) {
				_this.addSlides(slick.$slides.first().data('datetime'), 'prev');
				return true;
			}

			// append a couple of new slides to the end
			if (nextSlide > currentSlide && (slick.slideCount - currentSlide <= 5)) {
				_this.addSlides(slick.$slides.last().data('datetime'), 'next');
			}
		});
	},

	/**
	 * Returns initial slide position based on data-start attribute of the slides
	 * @returns {number}
	 */
	getStartPosition: function() {
		var startPosition = 0,
			count = 0;
		this.$container.find('.js-navigation-carousel-item').each(function(i, el) {
			if ($(el).data('start')) {
				startPosition = i;
			}
			count++;
		});

		// fix for unreachable items (without arrows)
		if (count <= 3) {
			return 0;
		}

		return startPosition;
	},

	/**
	 * Appends/prepends slides to the carousel depending on direction
	 * @param datetime
	 * @param direction
	 * @returns {boolean}
	 */
	addSlides: function(datetime, direction) {
		var _this = this;

		if (this.addingSlides) {
			return false;
		}

		this.addingSlides = true;
		var currentSlide = _this.$carousel.slick('slickCurrentSlide');

		$.ajax({
			url: this.$container.data('add-slides-url'),
			method: 'post',
			dataType: 'json',
			data: {
				datetime: datetime,
				direction: direction
			},
			success: function(response) {
				for (var i = 0; i < response.length; i++) {
					_this.$carousel.slick('slickAdd', response[i], null, direction == 'prev');
					_this.$carousel.slick('slickGoTo', currentSlide, true);
				}

				_this.addingSlides = false;
			}
		})
	}
};

navigationCarousel.init();